import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_RECOMMENDATIONS_PATH,
  GetRecommendationsErrorDto,
  GetRecommendationsRequestPathVariables,
  GetRecommendationsSuccessDto,
} from '@/api/rest/resources/types/recommendations';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type SuccessDto = GetRecommendationsSuccessDto;
type ErrorDto = GetRecommendationsErrorDto;

// TODO: MVP-5585 check endpoint and path params when API contract is available
export const useRecommendations = (organizationIdArg?: string) => {
  const orgId = useOrganizationId();

  const organizationId = organizationIdArg ?? orgId;

  assertIsDefined(organizationId, 'organizationId');

  const pathVariables: GetRecommendationsRequestPathVariables = { organization_id: organizationId };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_RECOMMENDATIONS_PATH, pathVariables);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', 'recommendations', pathVariables],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
